import * as React from "react";
import Svg, { Path } from "react-native-svg";

const ArrowRightSmall = ({ color }) => (
  <Svg width={5} height={10} fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path
      d="M.83 10a.714.714 0 0 0 .556-.265l3.45-4.285a.714.714 0 0 0 0-.907L1.265.258a.715.715 0 1 0-1.1.914L3.358 5 .272 8.828A.714.714 0 0 0 .83 10Z"
      fill={color || "#000"}
    />
  </Svg>
);

export default ArrowRightSmall;
